import { render, staticRenderFns } from "./MTableHeader.vue?vue&type=template&id=fbf20fde"
import script from "./MTableHeader.vue?vue&type=script&lang=js"
export * from "./MTableHeader.vue?vue&type=script&lang=js"
import style0 from "./MTableHeader.vue?vue&type=style&index=0&id=fbf20fde&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports